export const EVENT_NAME = {
  LOGOUT_BUTTON_CLICKED: "Logout Button Clicked",
  LOGOUT_PROCESS_INITIATED: " Logout Process Initiated"
};
